import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';

/**
 * MappingModeToggle Component
 * Allows users to switch between shared mappings and per-contact mappings
 */
const MappingModeToggle = ({ 
  mode, 
  onToggle, 
  disabled = false,
  className = ""
}) => {
  const isShared = mode === 'shared';
  
  return (
    <Card className={`mapping-mode-toggle mb-4 ${className}`}>
      <Card.Body>
        <Row className="align-items-center">
          <Col>
            <div>
              <h6 className="mb-1">
                <i className={`fas ${isShared ? 'fa-share-alt' : 'fa-users'} me-2`}></i>
                Mapping Configuration
              </h6>
              <p className="text-muted mb-0 small">
                {isShared 
                  ? "All contacts use the same field mappings (default behavior)" 
                  : "Each contact can have different field mappings (advanced configuration)"
                }
              </p>
            </div>
          </Col>
          <Col xs="auto">
            <Button 
              variant={isShared ? 'outline-primary' : 'outline-secondary'}
              size="sm"
              onClick={() => onToggle(isShared ? 'per_contact' : 'shared')}
              disabled={disabled}
              className="d-flex align-items-center"
            >
              <i className={`fas ${isShared ? 'fa-cog' : 'fa-undo'} me-2`}></i>
              {isShared ? 'Customize Per Contact' : 'Use Shared Mappings'}
            </Button>
          </Col>
        </Row>
        
        {!isShared && (
          <div className="mt-3">
            <div className="alert alert-info small mb-0">
              <i className="fas fa-info-circle me-2"></i>
              <strong>Per-Contact Mode:</strong> You can now configure different Salesforce fields for each contact. 
              This is useful when your Salesforce org stores contact information in different fields or objects.
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default MappingModeToggle; 